import { useAuth } from '../contexts/AuthContext';
import { ROLE_PERMISSIONS } from '../utils/roles';
import toast from 'react-hot-toast';

export const useGlobalPermission = () => {
  const { user } = useAuth();

  const hasPermission = (requiredPermission: string): boolean => {
    if (!user) return false;
    return ROLE_PERMISSIONS[user.role]?.includes(requiredPermission) || false;
  };

  return hasPermission;
};

export const usePermissionCheck = () => {
  const { user } = useAuth();

  const checkPermission = (requiredPermission: string): boolean => {
    if (!user) return false;
    return ROLE_PERMISSIONS[user.role]?.includes(requiredPermission) || false;
  };

  const requirePermission = (requiredPermission: string, action: () => void): void => {
    if (checkPermission(requiredPermission)) {
      action();
    } else {
      console.warn(`Permission denied: ${requiredPermission}`);
      toast.error(`Permission denied: ${requiredPermission}`);
    }
  };

  return { checkPermission, requirePermission };
};